import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { heightDesktopHeader, widthDesktopDrawer, widthTabletDrawer } = theme;

  return {
    root: {
      marginTop: heightDesktopHeader,
      marginLeft: widthDesktopDrawer,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        marginLeft: widthTabletDrawer
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: 0
      },
      "& .MuiBackdrop-root": {
        top: heightDesktopHeader,
        left: widthTabletDrawer,
        [theme.breakpoints.up(Breakpoints.LG_1280)]: {
          top: heightDesktopHeader,
          left: widthDesktopDrawer
        }
      },
      "& .MuiDialogContent-root": {
        padding: 0
      },
      "& .MuiDialog-container": {
        borderLeft: `1px solid ${theme.palette.text.hint}`
      },
      "& .MuiDialog-scrollPaper": {
        justifyContent: "flex-start"
      },
      "& .MuiPaper-elevation24": {
        boxShadow: "none"
      }
    }
  };
});
